module.exports = __webpack_public_path__ + "static/media/send.ce4838de.png";